<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-date-picker v-model="today" type="date" placeholder="选择日期" @change="search"
          :clearable="false" :editable="false" style="margin-left: 10px;"></el-date-picker>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="toexcel">表格导出</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="100%" style="width: 100%">
          <!-- <el-table-column align="center" label="日期" min-width="100" prop="riqi"></el-table-column> -->
          <el-table-column align="center" label="客户编号" min-width="100" prop="kehu"></el-table-column>
          <el-table-column align="center" label="合同号" min-width="100" prop="dingdanhao"></el-table-column>
          <el-table-column align="center" label="伞型" min-width="100" prop="xinghao"></el-table-column>
          <el-table-column align="center" label="规格型号" min-width="100" prop="guige"></el-table-column>
          <el-table-column align="center" label="合同数量" min-width="100" prop="shuliang"></el-table-column>
          <el-table-column align="center" label="伞布颜色" min-width="100" prop="yanse"></el-table-column>
          <el-table-column align="center" label="工序" min-width="100" prop="gongxu"></el-table-column>
          <el-table-column align="center" label="执行单价" min-width="100" prop="zhixingdanjia"></el-table-column>
          <el-table-column align="center" label="成控单价" min-width="100" prop="chengkongdanjia"></el-table-column>
          <el-table-column align="center" label="期初外协/库存核销" min-width="100" prop="qichuhexiao"></el-table-column>
          <el-table-column align="center" label="期初产量" min-width="100" prop="qichuchanliang"></el-table-column>
          <el-table-column align="center" label="期初金额" min-width="100" prop="qichujine"></el-table-column>
          <el-table-column align="center" label="当日外协/库存核销" min-width="150" prop="hexiao"></el-table-column>
          <el-table-column align="center" label="当日产量" min-width="100" prop="chanliang"></el-table-column>
          <el-table-column align="center" label="当日金额" min-width="100" prop="jine"></el-table-column>
          <el-table-column align="center" label="订单欠量" min-width="100" prop="dingdanqianliang"></el-table-column>
          <el-table-column align="center" label="本月外协/库存核销" min-width="100" prop="benyuekucun"></el-table-column>
          <el-table-column align="center" label="本月产量" min-width="100" prop="benyuechanliang"></el-table-column>
          <el-table-column align="center" label="本月执行金额" min-width="150" prop="benyuezhixing"></el-table-column>
          <el-table-column align="center" label="本月成控金额" min-width="150" prop="benyuechengkong"></el-table-column>
          <el-table-column align="center" label="累计外协/库存核销" min-width="100" prop="leijikucun"></el-table-column>
          <el-table-column align="center" label="累计产量" min-width="100" prop="leijichanliang"></el-table-column>
          <el-table-column align="center" label="累计金额" min-width="100" prop="leijijine"></el-table-column>
        </el-table>
      </div>
    </div>

    
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keywordType: 1,
      today: '',
      sf: '',
    }
  },

  created() {
    this.today = new Date();
    this.sf = localStorage.sf
    this.getList()
    
    
  },

  methods: {
    toexcel() {
      this.listLoading = true
      let data = {
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
        day: this.today.getDate()
      }
      if(this.keyword) {
        data.type = this.keywordType
        data.word = this.keyword
      }
      axios.post(this.$host+'/index.php/admin/Orderexcel/fengrenhetongExcel', data,
        {
          responseType: "blob", //二进制流
        }).then((res) => {
        const fileName = '缝纫合同日报表';
        this.downloadFile(res.data, fileName);
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
    
    // 下载文件
    downloadFile(blobData, fileName) {
      // 创建Blob对象
      const blob = new Blob([blobData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      
      // 创建下载链接
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; // 设置文件名
      
      // 触发下载
      document.body.appendChild(a);
      a.click();
      
      // 清理资源
      document.body.removeChild(a);
      URL.revokeObjectURL(url); // 释放URL对象
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.search()
    },
    
    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
        day: this.today.getDate()
      }
      if(this.keyword) {
        data.type = this.keywordType
        data.word = this.keyword
      }
      this.$request.post('/index.php/admin/index/fengrenhetong', data).then((res) => {
        this.list = res.data.data
        this.listLoading = false
        for(let i in this.list) {
          if(this.list[i].dingdanqianliang<0) {
            this.$message.error('有订单欠量为负数的数据')
          }
          if(this.list[i].shuliang==0&&this.list[i].shuliang!='') {
            this.$message.error('有合同数量为0的数据')
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
